export const HELP_CENTER_LINKS = {
  supportHomepage: 'https://support.watchfulhq.com/',
  helpCentreOverview: 'https://support.watchfulhq.com/en/articles/9755713',
  monitoring: 'https://support.watchfulhq.com/en/categories/1946817-monitoring',
  alerts: 'https://support.watchfulhq.com/en/articles/9036417',
  devices: 'https://support.watchfulhq.com/en/articles/9036097',
  users: 'https://support.watchfulhq.com/en/articles/9036225',
  teams: 'https://support.watchfulhq.com/en/articles/9036289',
  customers: 'https://support.watchfulhq.com/en/articles/9035969',
  sites: 'https://support.watchfulhq.com/en/articles/9036033',
  integrations: 'https://support.watchfulhq.com/en/articles/9541505',
  alertStatus: 'https://support.watchfulhq.com/en/articles/9036353#a',
  monitoringAgent: 'https://support.watchfulhq.com/en/articles/9036353#m',
  nvr: 'https://support.watchfulhq.com/en/articles/9036353#n',
  vms: 'https://support.watchfulhq.com/en/articles/9036353#v',
  contactUs: 'https://support.watchfulhq.com/en/contact-us',
  requests: 'https://support.watchfulhq.com/en/customer-portal',
} as const;
